const Footer = () => (
  <i>
    <footer className="bg-gray-800 text-white text-center p-4 mt-8">
      © 2025 Coffe – Vengan y disfrunten un buen Caffè :)
    </footer>
  </i>
);

export default Footer;
